import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateCharacters' })
export class TruncateCharactersPipe implements PipeTransform {
  /**
   * truncate text as per given conditions.
   * @param truncateText as String - text to be truncated.
   * @param value as Number - length of text to shown.
   * @param precisely as Boolean - if true, take space into consideration.
   * @param viewMore as Boolean - if true, return text AsItIs without truncate.
   */
  transform(truncateText: string, value: number, precisely = false, viewMore = false): string {
    if (viewMore) {
      return truncateText;
    }
    let splitArr: Array<string>;
    if (truncateText.length > value) {
      if (!precisely) {
        truncateText = truncateText.substring(0, value - 1);
      } else {
        if (truncateText.charAt(value) === ' ') {
          truncateText = truncateText.substring(0, value - 1);
        } else {
          truncateText = truncateText.substring(0, value - 1);
          splitArr = truncateText.split(' ');
          if (splitArr.length > 1) {
            splitArr.pop();
          }
          truncateText = splitArr.join(' ');
        }
      }
      truncateText += '...';
    }
    return truncateText;
  }
}
